import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import BuyImg from "../../../assets/images/buy.png";
import SellImg from "../../../assets/images/sell.png";
import RentImg from "../../../assets/images/rent.png";
import "./PropertyPurpose.css";

const CARDS = [
  {
    title: "Buy a Property",
    description:
      "Discover a wide variety of properties for sale in your preferred location. Whether you're looking for a cozy apartment, a spacious house, or a commercial space, find the perfect fit for your needs.",
    image: BuyImg,
    btnText: "Search Property",
  },
  {
    title: "Sell a Property",
    description:
      "Looking to sell your place? Our platform makes the selling process effortless, giving you all the tools to showcase your property and attract the right buyers quickly.",
    image: SellImg,
    btnText: "List Property",
  },
  {
    title: "Rent a Property",
    description:
      "Explore rental properties that fit your lifestyle and budget. Whether short-term or long-term, find the perfect place to call home with ease.",
    image: RentImg,
    btnText: "Search Property",
  },
];

const PropertyPurpose = () => (
  <section className="type-section">
    <div className="type-section__container">
      <div className="type-section__header">
        <span className="type-section__label">Explore options</span>
        <h2 className="type-section__title">
          What are you <em>looking for?</em>
        </h2>
      </div>

      <div className="type-section__grid">
        {CARDS.map(({ title, description, image, btnText }) => (
          <div key={title} className="type-section__card">
            <div className="type-section__card-img-wrap">
              <img src={image} alt={title} className="type-section__card-img" />
            </div>
            <h3 className="type-section__card-title">{title}</h3>
            <p className="type-section__card-text">{description}</p>
            <Link to="/login" className="type-section__card-btn">
              {btnText}
              <ArrowRight size={13} strokeWidth={2.5} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PropertyPurpose;
